<template>
  <div class="app">
    <!-- 永遠顯示的 NAV -->
    <nav class="nav">
      <router-link to="/" class="nav-logo">
        <img
          src="@/assets/logo.png"
          alt="綠憩植研 Logo"
          class="nav-logo-icon"
        />
        <div class="nav-logo-text">
          <span class="nav-logo-zh">綠憩植研</span>
          <span class="nav-logo-en">GREEN RICH GEAM</span>
        </div>
      </router-link>

      <ul class="nav-links" :class="{ 'nav-links-open': mobileMenuOpen }">
        <li>
          <router-link to="/about" @click="closeMobileMenu"
            >關於我們</router-link
          >
        </li>
        <li>
          <router-link to="/products" @click="closeMobileMenu"
            >商品商城</router-link
          >
        </li>
        <li>
          <router-link to="/services" @click="closeMobileMenu"
            >服務項目</router-link
          >
        </li>
        <li>
          <router-link to="/news" @click="closeMobileMenu"
            >最新消息</router-link
          >
        </li>
        <li>
          <router-link to="/faq" @click="closeMobileMenu">常見問題</router-link>
        </li>
        <li>
          <router-link to="/contact" @click="closeMobileMenu"
            >聯絡我們</router-link
          >
        </li>
      </ul>

      <div class="nav-actions">
        <router-link v-if="!isLoggedIn" to="/login" class="btn-nav">
          登入
        </router-link>
        <div v-else class="user-dropdown" @click="toggleDropdown">
          <span class="user-name">{{ displayName }} ▾</span>
          <div v-if="showDropdown" class="dropdown-menu">
            <router-link to="/admin/products" class="dropdown-item"
              >🪴 商品管理</router-link
            >
            <router-link to="/admin/services" class="dropdown-item"
              >🌱 服務管理</router-link
            >
            <router-link to="/admin/news" class="dropdown-item"
              >📰 最新消息</router-link
            >
            <router-link to="/admin/contacts" class="dropdown-item"
              >✉️ 聯絡表單</router-link
            >
            <div class="dropdown-divider"></div>
            <button @click.stop="logout" class="dropdown-item dropdown-logout">
              登出
            </button>
          </div>
        </div>
        <button
          class="menu-btn"
          @click="mobileMenuOpen = !mobileMenuOpen"
          aria-label="選單"
        >
          <span></span><span></span><span></span>
        </button>
      </div>
    </nav>

    <!-- 頁面內容在這裡 -->
    <router-view />
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import axios from "axios";

const router = useRouter();
const isLoggedIn = ref(!!localStorage.getItem("jwtToken"));
const displayName = ref(localStorage.getItem("displayName") || "");
const showDropdown = ref(false);
const mobileMenuOpen = ref(false);

const toggleDropdown = () => {
  showDropdown.value = !showDropdown.value;
};

const closeMobileMenu = () => {
  mobileMenuOpen.value = false;
};

const closeDropdown = (e) => {
  if (!e.target.closest(".user-dropdown")) {
    showDropdown.value = false;
  }
};

router.afterEach(() => {
  isLoggedIn.value = !!localStorage.getItem("jwtToken");
  displayName.value = localStorage.getItem("displayName") || "";
  showDropdown.value = false;
  mobileMenuOpen.value = false;
});

onMounted(() => {
  isLoggedIn.value = !!localStorage.getItem("jwtToken");
  displayName.value = localStorage.getItem("displayName") || "";
  document.addEventListener("click", closeDropdown);
});

const logout = () => {
  localStorage.removeItem("jwtToken");
  localStorage.removeItem("displayName");
  delete axios.defaults.headers.common["Authorization"];
  isLoggedIn.value = false;
  displayName.value = "";
  showDropdown.value = false;
  router.push("/");
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.app {
  font-family: "Noto Sans TC", "Microsoft JhengHei", sans-serif;
  background: #f7f5ef;
  color: #1c2b1a;
}

.nav {
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 40px;
  background: rgba(247, 245, 239, 0.95);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  transition: all 0.3s;
}

.nav-logo {
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  color: #1c2b1a;
  cursor: pointer;
}

.nav-logo-icon {
  width: 36px;
  height: 36px;
  object-fit: contain;
  border-radius: 6px;
}

.nav-logo-zh {
  display: block;
  font-weight: 600;
  font-size: 16px;
}

.nav-logo-en {
  display: block;
  font-size: 11px;
  color: #6b7f68;
  letter-spacing: 1px;
}

.nav-links {
  list-style: none;
  display: flex;
  gap: 40px;
}

.nav-links a {
  text-decoration: none;
  color: #1c2b1a;
  font-size: 14px;
  transition: color 0.3s;
}

.nav-links a:hover {
  color: #4e7b4f;
}

.nav-actions {
  display: flex;
  gap: 20px;
  align-items: center;
}

.btn-nav {
  padding: 8px 20px;
  background: #4e7b4f;
  color: white;
  border-radius: 20px;
  text-decoration: none;
  font-size: 14px;
  transition: all 0.3s;
}

.btn-nav:hover {
  background: #2d5016;
}

.user-dropdown {
  position: relative;
  cursor: pointer;
}

.user-name {
  padding: 8px 16px;
  background: #4e7b4f;
  color: white;
  border-radius: 20px;
  font-size: 14px;
  user-select: none;
  display: block;
}

.dropdown-menu {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  background: white;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  min-width: 180px;
  overflow: hidden;
  z-index: 200;
}

.dropdown-item {
  display: block;
  padding: 12px 16px;
  color: #1c2b1a;
  text-decoration: none;
  font-size: 14px;
  transition: background 0.2s;
  width: 100%;
  text-align: left;
  background: none;
  border: none;
  cursor: pointer;
  font-family: inherit;
}

.dropdown-item:hover {
  background: #f5f7fa;
  color: #4e7b4f;
}

.dropdown-divider {
  height: 1px;
  background: #eee;
  margin: 4px 0;
}

.dropdown-logout {
  color: #ff6b6b;
}

.dropdown-logout:hover {
  background: #fff5f5;
  color: #ff5252;
}

.menu-btn {
  display: none;
  flex-direction: column;
  gap: 5px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
}

.menu-btn span {
  display: block;
  width: 22px;
  height: 2px;
  background: #1c2b1a;
}

@media (max-width: 768px) {
  .nav {
    padding: 15px 20px;
  }

  .nav-links {
    display: none;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    flex-direction: column;
    gap: 0;
    background: #f7f5ef;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
    padding: 8px 0;
  }

  .nav-links-open {
    display: flex;
  }

  .nav-links li {
    width: 100%;
  }

  .nav-links a {
    display: block;
    padding: 14px 24px;
    font-size: 15px;
  }

  .menu-btn {
    display: flex;
  }
}
</style>
